module.exports = __webpack_public_path__ + "static/media/MTH_Low_Impact_Dance_Fitness_2.d446ce49.webp";